import {Pipe, PipeTransform} from '@angular/core';

import moment from 'moment-timezone';
import 'moment/locale/fr';

import { convertPhpDateFormatToMoment } from '../../../PageBuilder/helpers/timezone.helper';

@Pipe({
    name: 'agprDateString',
    standalone: false
})
export class DateStringPipe implements PipeTransform {
    constructor () {}
    transform(value: Date, format: string, timezone?: string, locale?: string) {
        let dateFormat;

        if (format) {
            dateFormat = convertPhpDateFormatToMoment(format);
        } else {
            dateFormat = 'MM/DD/YYYY';
        }

        if (value) {
            if (timezone) {
                return moment.tz(value, timezone).locale(locale || 'en').format(dateFormat);
            }
            return moment(value).locale(locale || 'en').format(dateFormat);
        } else {
            // No date value yet (e.g. Publish Date before the briefing is sent). Still honour
            // the timezone so that the z format token produces a named abbreviation.
            if (timezone) {
                return moment.tz(Date.now(), timezone).locale(locale || 'en').format(dateFormat);
            }
            return moment().locale(locale || 'en').format(dateFormat);
        }
    }
}
